export function isFranceCampusName(name) {
  return String(name || '').trim().toLowerCase() === 'france';
}
